<template>
    <div class="index">
        <header>
            <div class="h_left">
            <span>
                <i class="el-icon-menu" @click="isCollapse = ! isCollapse"></i>
            </span>

                <router-link to="home">
                    <span>{{platform_info.platform_name}}</span>
                </router-link>
            </div>
            <div class="h_right">
                <div class="toggle-screen" :title="fullScreen ? '恢复' : '全屏'">
                    <svg class="icon" aria-hidden="true" @click="toggleFullScreen">
                        <use :xlink:href="iconUrl"></use>
                    </svg>
                </div>
                <el-popover
                        placement="bottom-end"
                        trigger="hover">
                    <i slot="reference">
                        <img :src="platform_info.platform_logo" alt="user"/>
                    </i>
                    <p class="user-box" @click="personalCenter">个人中心</p>
                    <p class="user-box" @click="changePwd">修改密码</p>
                    <p class="user-box" @click="exit">注销</p>
                </el-popover>
            </div>
        </header>
        <section>
            <aside :class="[isCollapse? 'small' : 'big']">
                <el-menu :default-active="$store.state.active_status" :collapse="isCollapse"
                         active-text-color="#ffd04b" :unique-opened="u_opened" background-color="rgba(255,255,255,.2)"
                         text-color="#eee" menu-trigger="click" @select="handleMenu">
                    <el-menu-item class="items-first" index="0" style="background-color: transparent">
                        <img v-if="isCollapse"  :src="platform_info.user_avatar" alt="logo"/>
                        <div slot="title">
                            <p>
                                <i>
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-yonghu"></use>
                                    </svg> :
                                </i>
                                <span class="current_user">{{user_info.user_name}}</span>
                            </p>
                            <p>
                                <i>
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icon-riqi"></use>
                                    </svg> :
                                </i>
                                <span class="current_time" :title="nowTime">{{nowTime}}</span>
                            </p>
                        </div>
                    </el-menu-item>
                    <el-menu-item class="items-second" index="1" id="item1" @click="turn('1')" style="background-color: transparent">
                        <i>
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#icon-zhuye"></use>
                            </svg>
                        </i>
                        <span slot="title">主页</span>
                    </el-menu-item>
                    <el-submenu index="2" id="item2">
                        <template slot="title">
                            <i>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-xitong"></use>
                                </svg>
                            </i>
                            <span slot="title">系统管理</span>
                        </template>
                        <el-menu-item-group>
                            <!--<el-menu-item-->
                                    <!--v-for="item  in autoMenu"-->
                                    <!--:index="item.m_index"-->
                                    <!--@click="turn(item.m_index,item.m_router)"-->
                                    <!--:key="item.index" >-->
                                <!--{{item.m_name}}-->
                            <!--</el-menu-item>-->
                            <el-menu-item index="2-1" @click="turn('2-1')">制冷系统</el-menu-item>
                            <el-menu-item index="2-2" @click="turn('2-2')">新风系统</el-menu-item>
                            <el-menu-item index="2-3" @click="turn('2-3')">锅炉</el-menu-item>
                            <el-menu-item index="2-4" @click="turn('2-4')">地源热泵</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu index="3" id="item3">
                        <template slot="title">
                            <i>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-ziliaoku"></use>
                                </svg>
                            </i>
                            <span slot="title">资料管理</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item index="3-1" @click="turn('3-1')">文档资料</el-menu-item>
                            <el-menu-item index="3-2" @click="turn('3-2')">设备信息</el-menu-item>
                            <el-menu-item index="3-3" @click="turn('3-3')">水电管理</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu index="4" id="item4">
                        <template slot="title">
                            <i>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-jiankong"></use>
                                </svg>
                            </i>
                            <span slot="title">实时监控</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item index="4-1" @click="turn('4-1')">报警信息</el-menu-item>
                            <el-menu-item index="4-3" @click="turn('4-3')">KPI</el-menu-item>
                            <el-menu-item index="4-4" @click="turn('4-4')">运行报表</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu index="5" id="item5">
                        <template slot="title">
                            <i>
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#icon-pingtaiapicanshu"></use>
                                </svg>
                            </i>
                            <span slot="title">平台管理</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item index="5-1" @click="turn('5-1')">用户管理</el-menu-item>
                            <el-menu-item index="5-1" @click="turn('5-2')">平台配置</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                </el-menu>
            </aside>
            <main :class="[isCollapse? 'big_w' : 'small_w']" class="clearfix" style="overflow: auto">
                <router-view v-on:updatedInfo = "updatedInfo"/>
            </main>
        </section>
        <el-dialog :visible.sync = 'perCenterVisible' :close-on-click-modal="false" style="margin:auto">
            <div slot="title">
                <span>
                <i>
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-gerenzhongxin"></use>
                    </svg>
                </i>个人中心</span>
            </div>
            <div class="person-center">
                <table>
                    <tr>
                        <td><span>ID：</span><span>{{personalInfo.id}}</span></td>
                        <td><span>用户名：</span><span>{{personalInfo.username}}</span></td>
                    </tr>
                    <tr>
                        <td><span>权限：</span><span>{{personalInfo.grade}}</span></td>
                        <td><span>所属项目：</span><span>{{personalInfo.project_name}}</span></td>
                    </tr>
                    <tr>
                        <td><span>邮箱：</span><span>{{personalInfo.email}}</span></td>
                        <td><span>电话：</span><span>{{personalInfo.phone}}</span></td>
                    </tr>
                    <tr>
                        <td colspan="2"><span>上一次登陆时间：</span><span>{{personalInfo.last_login}}</span></td>
                    </tr>
                    <tr>
                        <td colspan="2"><span>备注：</span><span>{{personalInfo.remark}}</span></td>
                    </tr>
                </table>
            </div>
        </el-dialog>
        <el-dialog :visible.sync = 'changepwdVisible' :close-on-click-modal="false" style="width:75%;margin:auto">
            <div slot="title">
                <span>
                <i class="el-icon-edit-outline"></i>修改密码</span>
            </div>
            <div class="change-pwd">
                <table>
                    <tr>
                        <td><span>原密码:</span></td>
                        <td><span><el-input type="passwrod" v-model="userPwd.oldPwd" @focus="clearErr"></el-input></span></td></tr>
                    <tr>
                        <td><span>新密码:</span></td>
                        <td><span><el-input type="password" v-model="userPwd.newPwd" @focus="clearErr"></el-input></span></td></tr>
                    <tr>
                        <td><span>确认新密码:</span></td>
                        <td><span><el-input type="password" v-model="userPwd.checkNewPwd" @focus="clearErr"></el-input></span></td></tr>
                    <tr v-if="errorPrompt !== ''" class="cp-errPrompt">
                        <td colspan="2"><p>{{errorPrompt}}</p></td>
                    </tr>
                    <tr class="cp-submit">
                        <td colspan="2"><el-button type="primary" @click="changePwdSubmit">确认</el-button></td>
                    </tr>
                </table>
            </div>
        </el-dialog>
    </div>
</template>


<script>
  // import store from 'vuex'
  import {mapState, mapMutations} from 'vuex'
  // import {refreshing_token } from "../api/http";
  import {DecryptBase64, EncryptData} from "../assets/js/common/encrypt";

  export default {
    // store,
    data() {
      return {
        userPwd: {
          oldPwd: '',
          newPwd: '',
          checkNewPwd: '',
        },
        platform_info: {
          'platform_name': '武汉市民之家云霖数智智能化节能管控系统',
          'user_avatar': require('../assets/img/index/logo1.png'),
          'platform_logo': require('../assets/img/index/avatar.jpg')
        },
        fullScreen: false,
        isEmpty: false,
        errorPrompt: '',
        isCollapse: true,
        u_opened: true,
        perCenterVisible: false,
        changepwdVisible: false,
        nowTime: '',
        personalInfo: {},
        user_info: {
          user_name: '',
          user_grade: '',
          user_pro_id: '',
        },
        autoMenu: [],
        systemRouter: [
          {sr_name: '制冷系统', sr_router: 'cooling',},
          {sr_name: 'vav', sr_router: 'systemVav',},
          {sr_name: '新风系统', sr_router: 'airSys',},
          {sr_name: '锅炉系统', sr_router: '',},
          {sr_name: '供热系统', sr_router: '',},
          {sr_name: '空调系统', sr_router: '',},
          {sr_name: '水费', sr_router: '',},
        ]
      }
    },
    beforeCreate() {
    },
    created() {
      this.getUserInfo();
      let userName = DecryptBase64(localStorage.getItem('username'));
      if (userName) {
        this.user_info.user_name = userName;
      }
      else {
        this.$router.push({name: 'login'});
        localStorage.clear();
      }
      setInterval(() => {
        this.nowTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date());
      }, 1000);
    },
    mounted() {
      // if(localStorage.getItem('refresh_token'))
      // refreshing_token();
      this.getSysInfo();
      this.handleMenu(1, ['1']);
    },
    watch: {
      $route: {
        handler: function (val, oldval) {
          // console.log('深监听：',val, oldval);
        },
        deep: true
      },
    },
    computed: {
      ...mapState([
        'sysIdInfo'
      ]),
      iconUrl: function () {
        let currentIcon = '';
        if (this.fullScreen) currentIcon = '#icon-outfullscreen';
        else currentIcon = '#icon-fullscreen';
        return currentIcon;
      }
    },
    methods: {
      updatedInfo: function (data) {
        this.platform_info.user_avatar = data.avatarImgCode ?
          data.avatarImgCode : require('../assets/img/index/logo1.png');
        this.platform_info.platform_logo = data.logoImgCode ?
          data.logoImgCode : require('../assets/img/index/avatar.jpg');
        this.platform_info.platform_name = data.platform_name ?
          data.platform_name : this.platform_info.platform_name;
      },
      dateFtt(fmt, date) {//日期函数
        var o = {
          "M+": date.getMonth() + 1,                 //月份
          "d+": date.getDate(),                    //日
          "h+": date.getHours(),                   //小时
          "m+": date.getMinutes(),                 //分
          "s+": date.getSeconds(),                 //秒
          "q+": Math.floor((date.getMonth() + 3) / 3), //季度
          "S": date.getMilliseconds()             //毫秒
        };
        if (/(y+)/.test(fmt))
          fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
      },
      exit() {
        window.localStorage.clear();
        this.$router.push({name: 'login'});
      },
      getSysInfo() {
        const _this = this;
        this.systemRouter.forEach((item, index) => {
          if (window.localStorage.getItem(item.sr_name)) {
            _this.autoMenu.push({
              m_name: item.sr_name,
              m_index: '2-' + (index + 1),
              m_router: item.sr_router
            });
          }
        })
      },
      handleMenu(key, keypath) {
        let currentNode = document.getElementById('item' + keypath[0]);
        let oldNode = document.querySelector('.small > ul.el-menu > li.is-active');
        oldNode.querySelector('.icon').style['fill'] = '#acbff5';
        currentNode.querySelector('.icon').style['fill'] = '#889e41';
      },
      turn(index, to) {
        const _this = this;
        switch (index) {
          case '1':
            _this.$store.commit('changeMenu', '1');
            this.$router.push({name: 'home'});
            break;
          case '2-1':
            _this.$store.commit('changeMenu', '2-1');
            this.$router.push({name: 'coolingSys'});
            break;
          case '2-2':
            _this.$store.commit('changeMenu', '2-2');
            this.$router.push({name: 'airSys'});
            break;
          case '2-3':
            _this.$store.commit('changeMenu', '2-3');
            this.$router.push({name: 'boilerSys'});
            break;
          case '2-4':
            this.$store.commit('changeMenu','2-4');
            this.$router.push({ name: 'gshpSys' });
              break;
          case '3-1':
            this.$store.commit('changeMenu', '3-1');
            this.$router.push({name: 'filterInfo'});
            break;
          case '3-2':
            this.$store.commit('changeMenu', '3-2');
            this.$router.push({name: 'equipInfo'});
            break;
          case '3-3':
            this.$store.commit('changeMenu', '3-3');
            this.$router.push({name: 'weaElcMan'});
            break;
          case '4-1':
            this.$store.commit('changeMenu', '4-1');
            this.$router.push({name: 'alarmInfo'});
            break;
          case '4-2':
            this.$store.commit('changeMenu', '4-2');
            this.$router.push({name: 'systemVav'});
            break;
          case '4-3':
            this.$store.commit('changeMenu', '4-3');
            this.$router.push({name: 'KPI'});
            break;
          case '4-4':
            this.$store.commit('changeMenu', '4-4');
            this.$router.push({name: 'runningReport'});
            break;
          case '5-1':
            this.$store.commit('changeMenu', '5-2');
            this.$router.push({name: 'userMan'});
            break;
          case '5-2':
            this.$store.commit('changeMenu', '5-3');
            this.$router.push({name: 'platformConfig'});
            break;
        }
      },
      toggleFullScreen() {
        this.fullScreen = !this.fullScreen;
        if (this.fullScreen) {
          var docE = document.documentElement;
          if (docE.requestFullscreen) docE.requestFullscreen();
          else if (docE.mozRequestFullScreen) docE.mozRequestFullScreen();
          else if (docE.webkitRequestFullScreen) docE.webkitRequestFullScreen();
        } else {
          var doc = document;
          if (doc.exitFullscreen) doc.exitFullscreen();
          else if (doc.mozCancelFullScreen) doc.mozCancelFullScreen();
          else if (doc.webkitExitFullscreen) doc.webkitExitFullscreen();
        }
      },
      //个人中心
      personalCenter() {
        const _this = this;
        this.perCenterVisible = true;
        this.$api.userSelf.personalCenter(EncryptData({}))
          .then(res => {
            if (res.data.flag === 1) {
              _this.personalInfo = Object.assign({}, res.data.data);
            }
          })
      },
      changePwd() {
        for (let i in this.userPwd) {
          this.userPwd[i] = '';
        }
        this.changepwdVisible = true;
      },
      clearErr() {
        this.errorPrompt = '';
        this.isEmpty = false;
      },
      changePwdSubmit() {
        for (let i in this.userPwd) {
          if (this.userPwd[i] === '') {
            this.isEmpty = true;
            this.errorPrompt = '所填信息不能为空！';
          }
        }
        if (!this.isEmpty) {
          this.errorPrompt = '';
          if (this.userPwd.newPwd !== this.userPwd.checkNewPwd) {
            this.errorPrompt = '两次新密码不一致！';
          }
          else {
            this.errorPrompt = '';
            this.$api.userSelf.changePwd(EncryptData({old_pwd: this.userPwd.oldPwd, new_pwd: this.userPwd.newPwd}))
              .then(res => {
                if (res.data.flag === 1) {
                  this.$message.success(`${res.data.msg.zh},请重新登录`);
                  this.$router.push({name: 'login'});
                }
              })
          }
        }
      },
      getUserInfo(){
        const _this = this;
        this.$api.userSelf.personalCenter(EncryptData({}))
          .then(res => {
            if (res.data.flag === 1) {
              _this.personalInfo = Object.assign({}, res.data.data);
              _this.$store.commit({
                type: 'getuserInfo',
                info: _this.personalInfo,
              })
            }
          })
      }
    },
  };
</script>
<style lang="scss">
    @import "../assets/style/base";

    /*清除浮动代码*/
    .clearfloat:after{display:block;clear:both;content:"";visibility:hidden;height:0}
    .clearfloat{zoom:1}
    $fontSize1: .6rem;
    $wordSpacing01: .08rem;
    @mixin padding0 {
        padding: 0 !important;
    }
    @mixin imageStyle($size: 1.8rem){
        width: $size;
        height: $size;
        border-radius: 50%;
        overflow: hidden;
    }
    .index {
        position: absolute;
        height: 100%;
        width: 100%;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #a8c8da;
        background:#004050 url('../assets/img/index/bg.jpg');
        background-size: 100% 100%;
        header{
            display: flex;
            display: -webkit-flex;
            text-indent: .2rem;
            width: 100%;
            height: 6%;
            font-size: .8rem;
            background-color: rgba(255,255,255,.2);
            .h_left{
                width: 70%;
                height: 100%;
                display: flex;
                display: -webkit-flex;
                align-items: center;
                > span {
                    position: relative;
                    height:100%;
                    background-color: #4D7A94;
                    width: 5.714%;
                    line-height: 100%;
                    vertical-align: bottom;
                    .el-icon-menu{
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        margin-right: 2%;
                        min-width: 2.1rem;
                        font-size: 1.3rem;
                        color: #eee;
                    }
                }
                a {
                    margin-left: .5rem;text-decoration: none; color: #eee;&:hover{ color: #548db4 }}
                .router-link-active {text-decoration: none;}
            }
            .h_right {
                display: -webkit-flex;
                width: 29%;
                height: 100%;
                align-items: center;
                justify-content: flex-end;
                .toggle-screen{
                    margin-right: .5rem;
                    position: relative;
                    width: 9.5%;
                    height: 74%;
                    background-color: rgba(0,0,0,.08);
                    .icon{
                        position: absolute;
                        fill: #3ebae2;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 120%;
                        height: 120%;
                        vertical-align: 0;
                    }
                    &:hover{
                        box-shadow: 0 0 .4rem .06rem #65a4ff inset;
                        .icon{
                            width: 130%;
                            height: 130%;
                        }
                    }
                }
                i{
                    img{
                        vertical-align: text-bottom;
                        @include imageStyle(1.6rem);
                    }
                    font-size: 1rem;
                }

            }
        }
        >section{
            float: right;
            width: 100%;
            height: 94%;
            font-size: 1rem;
            min-width: 50rem;
            aside{
                height: 100%;
                .el-menu {
                    width: 100%;
                    height: 100%;
                    .el-menu-item {
                        width: 100%;
                        height: 2.3rem;
                        line-height: 2.5rem;
                        text-align: center;
                        min-width: unset;
                        img{
                            @include imageStyle;
                        }
                        p{
                            i{
                                vertical-align: middle;
                                .icon{
                                    vertical-align: -78%;
                                }
                            }
                            span {
                                vertical-align: middle;
                                font-size: $fontSize1;
                                letter-spacing: $wordSpacing01;
                                &.current_time {
                                    display: inline-block;
                                    width: 99%;
                                    height: 1.2rem;
                                    line-height: 1.2rem;
                                    letter-spacing: 0;
                                    overflow-x: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }
                            }
                        }
                    }
                    .el-submenu{
                        margin: 1.4rem auto;
                        span {
                            font-size: $fontSize1;
                            letter-spacing: $wordSpacing01;
                        }
                    }
                    .icon{
                        fill: #acbff5;
                    }
                }
            }
            main{
                height: 100%;
                float: right;
                /*background-color: #eee;*/
            }
        }
        .el-dialog{/*更换密码和用户中心*/
            background-color: rgba(200,200,200,.95);
            .el-dialog__header{
                span{
                    color: #569dff;
                    .icon{
                        margin-right: .2rem;
                        font-size: .75rem;
                    }
                }
            }
            .person-center{
                width: 100%;
                table{
                    width: 100%;
                    tr{
                        width: 100%;
                        border-bottom: 1px solid #eee;
                        td{
                            width: 50%;
                            line-height: 2rem;
                            font-size: .7rem;
                            text-align: left;
                            text-indent: .5rem;
                            span{
                                &:nth-child(even){//偶数
                                    color: #555;
                                }
                                &:nth-child(odd){
                                    color: #284157;
                                    font-size: 85%;
                                }
                            }
                        }
                    }
                }
            }
            .change-pwd{
                width: 100%;
                table{
                    width: 100%;
                    tr{
                        height: 2rem;
                        line-height: 2rem;
                        margin-top: .1rem;
                        width: 100%;
                        text-align: center;
                        td:nth-child(1) {
                            width: 30%;
                            text-align: right;
                        }
                        td:nth-child(2) {
                            width: 70%;
                            text-align: left;
                            .el-input{
                                margin-left: .5rem;
                                width: 65%;
                            }
                        }
                    }
                    tr.cp-errPrompt{
                        td{
                            text-align: center;
                            color: red;
                        }
                    }
                    tr.cp-submit{
                        td{
                            text-align: center;
                        }
                    }
                }
            }
        }
    }
    .big{
        width: 12%;
        height: 100%;
        min-width: 6.2rem;
        float: left;
        background: #424d58;
        .icon{
            margin-left: -.5rem;
            margin-right: .1rem;
        }
        p{
            margin: 0;
            padding-top: .3rem;
            text-align: left;
            height: 47%;
            line-height: 47%;
            font-size: 80%;
        }
        span{
            vertical-align: sub;
        }
        .el-menu .el-menu-item:nth-child(1){
            background-color: #eee;
        }
        li[class*='items-']{
            font-size: .65rem;
        }
        .el-submenu__icon-arrow{
            margin-top: .1rem!important;
        }
        .el-menu-item{
            height: .56rem;
            line-height: .56rem;
            &.items-first{
                background-color: #aaa!important;
                color: #333!important;
                &:hover{
                    background-color: #aaa!important;
                }
            }
        }
        .is-opened{
            .el-menu-item-group li{
                font-size: .55rem;
                &:hover{/*展开的菜单子项*/
                    background: -moz-linear-gradient(90deg, rgba(0,50,200,.4), rgba(255,255,255,.15));
                    background: -webkit-linear-gradient(90deg, rgba(0,50,200,.4), rgba(255,255,255,.15));
                    background: -o-linear-gradient(90deg, rgba(0,50,200,.4), rgba(255,255,255,.15));
                    background: linear-gradient(90deg, rgba(0,50,200,.4), rgba(255,255,255,.15));
                }
            }
        }
    }
    .small{
        width: 4%;
        height: 100%;
        min-width: 2.1rem!important;
        float: left;
        .el-menu {
            height: 100%;
            display: -webkit-flex;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            background-color: rgba(255,255,255,.1);
            border-right: none;
            li{
                &:hover {
                    background-color: unset;
                    .el-submenu__title{
                        background-color: unset;
                    }
                }
                .icon{
                    font-size: 1rem;
                }
                .el-menu--collapse{
                    width: 100%;
                }
                .el-submenu, .el-menu-item{
                    text-align: center;
                }
                .el-submenu .el-menu-item{
                    text-indent: .2rem;
                }
            }
        }
    }
    .small_w{
        width: 87.8%;
    }
    .big_w{
        width: 95.8%;
    }
    /*          复写侧边栏菜单style          */
    ul.el-menu{
        li.el-menu-item{
            background-color: transparent!important;
            &[class*='items-']:hover{
                background-color: transparent!important;
            }
            .el-submenu__title, .el-tooltip {
                @include padding0;
            }
            .el-menu--vertical {
                margin-left: 0!important;
            }
            .el-icon-arrow-down{
                margin-top: 0!important;
            }
        }
        li.el-submenu{
            .el-submenu__title{/*hover title*/
                padding: .3rem!important;
                background-color: transparent!important;
            }
        }
    }
    .el-tooltip__popper {
        margin-top: .3rem!important;
        padding: .5rem 1rem!important;
        margin-left: 0!important;
        &.is-dark {
            color: #222!important;
            background-color: rgba(255,255,255, .7)!important;
        }
    }
    .el-menu--vertical{
        width: 7rem!important;
        overflow: hidden;
        .el-menu--popup{/*子菜单hover悬浮板块*/
            background-color: rgba(255, 255, 255, .8)!important;
        }
        .el-menu-item-group li:not([class*='items']){/*//hover悬浮菜单条目*/
            text-indent: .5rem;
            padding: 0 .6rem!important;
            font-weight: bold;
            &:not([class*='is-active']){
                color: #222!important;
            }
        }
        .el-menu-item-group li.is-active{
            color: #889e41 !important;
        }
        .el-menu-item-group li:hover{
            background: -moz-linear-gradient(90deg, rgba(0,50,200,.6), rgba(255,255,255,.3));
            background: -webkit-linear-gradient(90deg, rgba(0,50,200,.6), rgba(255,255,255,.3));
            background: -o-linear-gradient(90deg, rgba(0,50,200,.6), rgba(255,255,255,.3));
            background: linear-gradient(90deg, rgba(0,50,200,.6), rgba(255,255,255,.3));
        }
    }
    .el-popover{
        p.user-box{
            color: #aaa;
            cursor: pointer!important;
            &:hover{
                color: orange;
            }
        }
    }

</style>
